import { cn } from '@seen/ui'
import { IconCheck } from '@tabler/icons-react'
import type { JSX, ReactNode } from 'react'
import { LabelColor } from '#src/components/LabelColor.tsx'

export function LabelOption({
  color,
  label,
  isSelected,
}: {
  color: string
  label: ReactNode
  isSelected?: boolean
}): JSX.Element {
  return (
    <div className="flex flex-1 items-center justify-between">
      <div className="flex items-center gap-2">
        <LabelColor color={color} />
        <span className="line-clamp-2">{label}</span>
      </div>
      <IconCheck
        className={cn(
          'mr-0.5 size-4 shrink-0 opacity-0',
          isSelected && 'opacity-100'
        )}
      />
    </div>
  )
}
